import { FolkShape } from '../folk-shape';
FolkShape.define();
export { FolkShape };
//# sourceMappingURL=folk-shape.js.map